import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api/axiosInstance";

export const loginThunk = createAsyncThunk(
  "auth/login",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await api.get(`auth/me`, credentials);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Login failed");
    }
  }
);